import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, Router } from '@angular/router';
import { WidgetItem } from '../../models/widgets/widget-item';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-widget-item',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './widget-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-item.component.scss',
})
export class WidgetItemComponent {
  private _router = inject(Router);

  @Input() public item: WidgetItem;

  public goToPage(): void {
    if (!this.item.actionRoute) {
      return;
    }
    this._router.navigate([this.item.actionRoute], {
      queryParams: this.item.actionQueryParams,
    });
  }
}
